<template>
  <div class="tree-form">
    <!-- <div class="tree-form-title">机构管理</div> -->
    <tree-form ref="treeform"
      nodeKey='regulatorId'
      :max-level="2"
      :props="defaultProps"
      :fetchData="fetchData"
      @node:append="nodeAppend"
      @node:remove="nodeRemove"
      @node:edit="nodeEdit"
      @node:look="nodeLook"
      look-scope='all'
      :task="['append', 'remove','edit','look']" />
    <el-dialog :title="type === 'add' ? '新增机构' : '编辑机构'"
      :visible.sync="dialogVisible"
      width="400px"
      @closed="handleClose"
      :before-close="handleBeforeClose">
      <el-form :model="nodeData"
        :rules="rules"
        ref="ruleForm"
        label-width="90px">
        <el-form-item label="机构名称"
          prop="regulatorName">
          <el-input v-model="nodeData.regulatorName"></el-input>
        </el-form-item>
        <el-form-item v-if="type === 'add'"
          label="机构账号"
          prop="adminAccount">
          <el-input v-model="nodeData.adminAccount"></el-input>
        </el-form-item>
        <el-form-item v-if="type === 'add'"
          label="监管贸易"
          prop="tradeType">
          <el-radio-group v-model="nodeData.tradeType">
            <el-radio-button :label="1">进出口</el-radio-button>
            <el-radio-button :label="3">国内</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上级机构"
          v-if="nodeData.parentId">
          {{nodeData.parentId ? nodeData.parentLabel : '无'}}
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleCancel"
          :loading="loading">取 消</el-button>
        <el-button type="primary"
          @click="handleSubmit"
          :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TreeForm from '@/components/public/tree-form.vue'
import _ from 'lodash'
export default {
  name: 'organization-form',
  components: { TreeForm },
  props: {},
  data () {
    return {
      loading: false,
      dialogVisible: false,
      defaultProps: {
        label: 'regulatorName',
        children: 'children'
      },
      nodeData: {},
      type: '',
      rules: {
        tradeType: [{ required: true, message: '请输入监管贸易', trigger: 'blur' }],
        regulatorName: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        adminAccount: [{ required: true, message: '请输入机构账号', trigger: 'blur' }]
      },
      current: null
    }
  },
  methods: {
    handleBeforeClose (done) {
      this.cancel && this.cancel()
      done()
    },
    handleCancel () {
      this.dialogVisible = false
      this.cancel && this.cancel()
    },
    handleSubmit () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.type === 'add') {
            this.$store.dispatch('supervise/addregulator', {
              payload: {
                ...this.nodeData,
                parentRegulatorId: this.nodeData.parentId
              },
              success: (res) => {
                this.loading = false
                this.$message.success('添加成功!')
                this.callback && this.callback()
                this.dialogVisible = false
              },
              fail: () => {
                this.loading = false
              }
            })
          }
          if (this.type === 'edit') {
            this.$store.dispatch('supervise/updateregulator', {
              payload: {
                ...this.nodeData,
                parentRegulatorId: this.nodeData.parentId
              },
              success: (res) => {
                this.loading = false
                this.$message.success('编辑成功!')
                this.callback && this.callback()
                this.dialogVisible = false
              },
              fail: () => {
                this.loading = false
              }
            })
          }
        }
      })
    },
    handleClose () {
      this.callback = null
      this.nodeData = {}
      this.cancel = null
      this.type = ''
      this.$refs.ruleForm.resetFields()
    },
    fetchData ({ callback, fail }) {
      this.$store.dispatch('supervise/getallregulators', {
        payload: {},
        type: 'list',
        success: (res) => {
          callback(res.data.regulators)
          if (this.current) {
            this.$nextTick(() => {
              this.$refs.treeform.getTreeRefs().setCurrentKey(this.current.regulatorId)
            })
          }
        },
        fail: () => {
          fail && fail()
        }
      })
    },
    nodeAppend ({ data, callback, cancel }) {
      this.callback = callback
      this.cancel = cancel
      this.nodeData = _.cloneDeep(data)
      this.type = 'add'
      this.dialogVisible = true
    },
    nodeEdit ({ data, callback, cancel }) {
      this.callback = callback
      this.cancel = cancel
      this.nodeData = _.cloneDeep(data)
      this.type = 'edit'
      this.dialogVisible = true
    },
    nodeRemove ({ data, callback, cancel }) {
      this.$confirm('此操作将永久删除该类别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('supervise/deleteregulator', {
            payload: data,
            success: (res) => {
              this.loading = false
              this.$message.success('删除成功!')
              callback && callback()
            },
            fail: () => {
              this.loading = false
              cancel && cancel()
            }
          })
        })
        .catch(() => {
          cancel && cancel()
        })
    },
    nodeLook ({ data, callback, cancel }) {
      this.current = data
      this.$emit('emit:task', data)
    }
  }
}
</script>
